import React from 'react';

import { BaseIconProps } from '.';

export const LocationTwo = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(19.720624,0,0,19.720624,-3203.7238,-27123.036)"
    d="m 189.838,1401.378 a 6.848,6.848 0 0 1 -6.846,-6.846 6.848,6.848 0 0 1 6.846,-6.846 6.848,6.848 0 0 1 6.845,6.846 6.848,6.848 0 0 1 -6.845,6.846 z m 0,-26.014 c -10.597,0 -19.168,8.571 -19.168,19.168 0,14.376 19.168,35.597 19.168,35.597 0,0 19.168,-21.221 19.168,-35.597 0,-10.597 -8.571,-19.168 -19.168,-19.168 z"
    fill={fill}
  />
);
